<template>
  <div>
    <div class="upload">
      <ul v-if="files.length" class="pl-0">
        <li class="upload-file" v-for="file in files" :key="file.id">
          <div class="upload-file__thumb"></div>
          <div class="upload-file__body">
            <div class="d-flex">
              <span class="upload-file__filename">{{ file.name }}</span>
              <span class="small d-block ml-1 mr-1">-</span>
              <span class="small">{{ file.size | formatFileSize }}</span>
              <button
                @click.prevent="removeFile(file)"
                size="sm"
                class="upload-file__delete ml-auto"
              >
                <svg-icon icon="cross" class="icon-xs" />
              </button>
            </div>
            <div
              v-if="fileProcess.preview !== null"
              class="image-preview text-center"
            >
              <img :src="fileProcess.preview" />
            </div>
          </div>
        </li>
      </ul>
      <div v-else class="text-center pb-5 pt-2">
        <strong>{{ $t('dropFilesHere') }}</strong> <br />
        <strong>{{ $t('or') }}</strong> <br />
        <label for="file" class="btn btn-sm btn-primary">
          {{ $t('selectFiles') }}
        </label>
        <br />
      </div>
      <div class="d-flex">
        <file-upload
          :multiple="false"
          :drop="true"
          :drop-directory="true"
          :upload-auto="false"
          @input-file="processFile"
          v-model="files"
          ref="upload"
        />
      </div>
    </div>
    <div class="text-right">
      <button
        id="submit-creative"
        :disabled="disabled"
        @click="submit()"
        class="btn btn-primary"
      >
        {{ $t('save') }}
      </button>
    </div>
  </div>
</template>

<script>
import FileUpload from 'vue-upload-component';
import { mapActions } from 'vuex';

export default {
  props: {
    preDefined: {
      type: Boolean,
      default: false
    },
    format: {
      type: Object,
      default: () => ({})
    }
  },

  components: {
    FileUpload
  },

  data() {
    return {
      creativeTypes: [],
      creativeFormats: [],
      creativeTags: [],
      form: {
        filename: null,
        creativeType: null,
        creativeFormat: null,
        newTagName: null,
        selectedTag: null
      },
      files: [],
      errors: {},
      image: null,
      newTag: false,
      disabled: true,
      fileProcess: {
        base64Reader: new FileReader(),
        busy: false,
        preview: null,
        data: null,
        checkingBinary: null
      }
    };
  },

  computed: {
    userId() {
      return this.$store.getters.user.id;
    },
    creativeTypeName() {
      if (!this.creativeTypes.length || !this.form.creativeType) return null;
      return this.form.creativeType[0].name;
    },
    creativeFormatsByType() {
      if (!this.creativeTypeName || !this.creativeFormats.length)
        return this.creativeFormats;
      return this.creativeFormats.filter(
        format => format.type === this.creativeTypeName
      );
    }
  },

  methods: {
    ...mapActions({
      fetchCreativeTypes: 'advert/fetchCreativeTypes',
      fetchCreativeFormats: 'advert/fetchCreativeFormats',
      fetchAdvertCreativeTags: 'advert/fetchAdvertCreativeTags'
    }),
    generateBase64() {
      this.fileProcess.preview = this.fileProcess.base64Reader.result;
      clearTimeout(this.fileProcess.busy);
    },
    processFile(newFile) {
      if (!newFile) return;
      if (this.fileProcess.busy) clearTimeout(this.fileProcess.busy);
      this.fileProcess.busy = setTimeout(() => {
        this.fileProcess.base64Reader.readAsDataURL(this.files[0].file);
      }, 500);
    },
    updateFile(val) {
      this.form.filename = val[0].name;
      this.$refs.upload.active = true;
    },
    clearFiles() {
      this.files = [];
      this.file.preview = null;
      // this.file.data = null;
    },
    removeFile(file) {
      this.$refs.upload.remove(file);
      this.image = null;
      this.fileProcess.preview = null;
    },

    generateBinary() {
      return new Promise((resolve, reject) => {
        const fr = new FileReader();
        fr.onload = () => {
          resolve(fr.result);
        };
        // fr.readAsBinaryString(this.files[0].file);
        fr.readAsArrayBuffer(this.files[0].file);
      });
    },
    async submit() {
      const binaryFile = await this.generateBinary();
      const newCreative = {};
      const int8Array = Array.from(new Int8Array(binaryFile));
      const creativeType = this.files[0].type.split('/')[0];
      newCreative.data = int8Array;

      newCreative.tag = !this.newTag
        ? this.form.selectedTag[0]
        : this.form.newTagName;

      newCreative.ownerID = this.userId;

      if (this.newTag) {
        const newTag = { title: this.form.newTagName };
        this.$api.adnet
          .post(`/v0/advert-creative-tags/${this.userId}`, newTag)
          .then(
            () => {},
            e => {
              if (e.response.data.errors) {
                this.errors = this.$parseErrors(e.response.data.errors) || {};
              } else {
                e.response.data.detail &&
                  this.$notify('alert', {
                    text: e.response.data.detail,
                    variant: 'danger',
                    time: 0
                  });
              }
            }
          );
      }

      this.$api.adnet.post(`/dsp/creatives/${creativeType}`, newCreative).then(
        () => {
          this.errors = {};
          this.$emit('form-submitted', { success: true });
          this.$notify('alert', {
            text: `New creative added.`,
            variant: 'success',
            time: 5000
          });
          this.newGroupName = '';
        },
        e => {
          this.errors = {};

          if (e.response.data.errors) {
            this.errors = this.$parseErrors(e.response.data.errors) || {};
          } else {
            this.$emit('form-submitted', { success: false });
            e.response.data.detail &&
              this.$notify('alert', {
                text: e.response.data.detail,
                variant: 'danger',
                time: 0
              });
          }
        }
      );
    }
  },

  watch: {
    files(files) {
      if (!files || !this.$refs.upload) return;
      this.$refs.upload.active = true;
    },
    'form.creativeType': {
      handler() {
        if (this.preDefined) return false;
        this.form.creativeFormat = [this.creativeFormatsByType[0]];
      }
    },
    'fileProcess.preview'() {
      this.disabled = this.fileProcess.preview !== null ? false : true;
    }
  },

  created() {
    this.fetchAdvertCreativeTags(this.userId)
      .then(res => {
        this.creativeTags = res;
        this.form.selectedTag = [res[0]];
      })
      .catch(e => e);

    this.fileProcess.base64Reader.addEventListener(
      'load',
      this.generateBase64,
      false
    );
  },

  beforeDestroy() {
    this.fileProcess.base64Reader.removeEventListener(
      'load',
      this.generateBase64
    );
  }
};
</script>

<style lang="scss" scoped>
.upload {
  ul {
    list-style: none;
  }

  .image-preview {
    img {
      display: inline-block;
      max-width: 100%;
    }
  }
}

.upload-file {
  &__filename {
    color: $light;
    display: block;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    max-width: 220px;
    font-size: 0.8rem;
  }

  &__delete {
    cursor: pointer;
    border: none;
    padding: 0;
    outline: none;

    &:hover {
      color: $primary;
    }
  }
}
</style>
